import { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export type NoOptionsMessageProps<OptionType extends CascaderOption> =
  BoxProps & {
    getCommonProps: () => CascaderCommonProps<OptionType>;
  };

export const InternalNoOptionsMessage = <
  OptionType extends CascaderOption,
>() => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomNoOptionsMessage = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.NO_OPTIONS_MESSAGE),
    [getComponent],
  );

  return (
    <CustomNoOptionsMessage
      getCommonProps={getCommonProps}
      __css={cascaderStyles.noOptionsMessage}
      className="cascader-no-options-message"
    />
  );
};

export const NoOptionsMessage = <OptionType extends CascaderOption>({
  getCommonProps: _,
  ...rest
}: NoOptionsMessageProps<OptionType>) => {
  return <Box {...rest}>No results found</Box>;
};
